import axios from "../http";

class Financial {
  /* 财务列表 */
  static getFinancial(type, pageNo, billDate, customerId, projectName, warehouseId) {
    const url = `/zwy/api/bill/list?type=${type}&pageNo=${pageNo}&billDate=${billDate}&customerId=${customerId}&projectName=${projectName}&warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 账单详情 */
  static getDetails(id) {
    const url = `/zwy/api/bill/detail/${id}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });

  }
  /* 调整明细费用 */
  static postAdjust(data) {
    const url = `/zwy/api/bill/adjust`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 调整记录列表 */
  static getRecordsList(billFeeDetailId) {
    const url = `/zwy/api/bill/list/adjust?billFeeDetailId=${billFeeDetailId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 登记记录列表 */
  static getLoginRecordsList(billDate, projectId, chargeServiceId) {
    const url = `/zwy/api/charge/check/bill/list?billDate=${billDate}&projectId=${projectId}&chargeServiceId=${chargeServiceId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 编辑其他费用 */
  static postModifyOther(data) {
    const url = `/zwy/api/bill/modify/other`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 核实账单 */
  static postVerify(data) {
    const url = `/zwy/api/bill/check`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 发送账单 */
  static postSend(data) {
    const url = `/zwy/api/bill/send`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改备注 */
  static postModifyRemarks(data) {
    const url = `/zwy/api/bill/modify/remarks`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改附件 */
  static postModifyAttachments(data) {
    const url = `/zwy/api/bill/modify/attachments`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 索赔记录列表 */
  static getCliamRecordsList(billDate, projectId) {
    const url = `/zwy/api/charge/check/list/claim/bill?billDate=${billDate}&projectId=${projectId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 导出账单 */
  static getExport(data, type) {
    let url
    if (type === 2) {
      url = `/zwy/api/download/bill/month`;
    } else {
      url = `/zwy/api/download/bill/day`;
    }
    return axios.post(url, data, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
  /* 账单批量核实 */
  static postBatchVerification(data) {
    const url = `/zwy/api/bill/batch/check`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 账单重算 */
  static postBillRecalculation(data) {
    const url = `/zwy/api/bill/handle/bill`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Financial;